<template>
	<div class="uk-container-expand">


<nav class="uk-navbar-container uk-margin uk-visible@s" uk-navbar>
<div class="dash_logo">
<router-link  to="/" exact active-class="uk-active"><a class="logo"><img src="/img/logo_dash2.jpg" /></a></router-link>
</div>
</nav>



<div class="uk-navbar-container wrapMenu" uk-navbar>
<div class="uk-navbar-center ">
	<router-link tag="li" to="/shops" active-class="uk-active"><a>Магазины</a></router-link>
	<router-link tag="li" to="/products" active-class="uk-active"><a>Продукция</a></router-link>
	<router-link tag="li" to="/blog" active-class="uk-active"><a>Блог</a></router-link>
	<router-link tag="li" to="/contacts" active-class="uk-active"><a>Контакты</a></router-link>
</div>
</div>




<nav class="uk-navbar uk-navbar-container leftMenu uk-hidden@s uk-visible" >
    <div class="uk-navbar-left">
        <a class="uk-navbar-toggle" href="#offcanvas-usage" uk-toggle>
            <span uk-navbar-toggle-icon></span> <span class="uk-margin-small-left">Меню</span>
        </a>
    </div>
</nav>




<div id="offcanvas-usage"  uk-offcanvas="overlay: true; mode: reveal">
    <div class="uk-offcanvas-bar">

        <ul class="offLeftNav uk-nav">
					<router-link  to="/" exact active-class="uk-active"><a class="leftMenuLogo uk-offcanvas-close"><img src="/img/logo.png" /></a></router-link>

					<router-link   tag="li" to="/shops" active-class="uk-active"><a class="uk-offcanvas-close" >Магазины</a></router-link>
          <router-link  tag="li" to="/products" active-class="uk-active"><a class="uk-offcanvas-close">Продукция</a></router-link>
					<router-link  tag="li" to="/blog" active-class="uk-active"><a class="uk-offcanvas-close">Блог</a></router-link>
          <router-link  tag="li" to="/contacts" active-class="uk-active"><a class="uk-offcanvas-close">Контакты</a></router-link>
				</ul>

    </div>
</div>

	</div>
</template>



<script>
export default {
	data () {
		return {

		}
	}
}
</script>



<style>

.wrapMenu {
	/* margin-top: 105px; */
}

.wrapMenu li {
	list-style: none;
}

.wrapMenu li a{
	color:#37474F;
	text-decoration: none;
	text-transform: uppercase;
	font-weight: 700;
	margin: 0 15px;
	background-color: rgb(255, 255, 255, .8);
	padding: 2px 5px;
}





.dash_logo {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10px;
}

.dash_logo .logo img {
	width: 960px;
	margin: 0 auto;
}

.leftMenuLogo img {
	width: 100px;
	margin-bottom: 20px;
}





.offLeftNav .uk-offcanvas-close{
	position: static;
}

.offLeftNav {
	display: flex ;
	flex-direction: column ;
}

.offLeftNav li {
	display: block;
}

.offLeftNav li a{
	display: block;
}






@media (max-width: 639px) {
  .wrapMenu {
		display: none;
	}
}



</style>